/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:f8eb5282-7f0c-418d-8eac-18cbed304a70",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ZKsRoezcg",
    "aws_user_pools_web_client_id": "6f4qtd08k5piv8nbv2bfrk3kmm",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_appsync_graphqlEndpoint": "https://5dtttaop5fcthltjtrd5rbk7ui.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "API": {
        "GraphQL": {
            "endpoint": "https://5dtttaop5fcthltjtrd5rbk7ui.appsync-api.us-east-1.amazonaws.com/graphql",
            "region": "us-east-1",
            "defaultAuthMode": "iam"
        }
    }
};


export default awsmobile;
